import { calculateHash } from '@client/common/utils/object/object';
import { FiltersValuesType } from 'b2b-common/core/catalog/Catalog.types';

export const calculateCatalogQueryHash = (
  categoryFilter: string,
  facetFilters: FiltersValuesType,
  paginationFilters: FiltersValuesType,
  query: string,
  language: string,
): string => calculateHash({
  categoryFilter,
  facetFilters,
  paginationFilters,
  query,
  language,
});
